import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1f337d',
    secondary: '#F4F4F5',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

var showLogoLogin = true
var headerTextDark = true

switch (window.env.VUE_APP_AMBIENTE) {
  case 'agiliza':
    themes = {
      light: {
        primary: '#1f337d',
        secondary: '#F4F4F5',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'lucash':
    themes = {
      light: {
        primary: '#2c3753',
        secondary: '#eae7d8',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    break
  case 'autobanking':
    themes = {
      light: {
        primary: '#6D4B9E',
        secondary: '#f7f7f7',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    showLogoLogin = false
    break
  case 'gente':
    themes = {
      light: {
        primary: '#002733',
        secondary: '#8EE000',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      },
    }
    showLogoLogin = false
    break
}
let background = '/assets/imgs/background.svg'
let logo = '/assets/imgs/logo.svg'

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg')
    background = '/assets/imgs/' + localStorage.ambiente + '/background.svg'
  }
} catch { }
try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo.svg')
    logo = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'

    var favicon = document.getElementById('custom-favicon')
    favicon.setAttribute('href', '/assets/imgs/' + localStorage.ambiente + '/favicon.svg')
  }
} catch { }

var backgroundHome = null
var logoHome = '/assets/imgs/' + localStorage.ambiente + '/logo-inverted.svg'
var logoLogin = '/assets/imgs/' + localStorage.ambiente + '/logo.svg'
switch (window.env.VUE_APP_AMBIENTE) {
  case 'gente':
    backgroundHome = 'assets/imgs/gente/background-home.svg'
    logoHome = '/assets/imgs/gente/logo.svg'
    logoLogin = '/assets/imgs/gente/logo-inverted.svg'
    break;
}

export default {
  dark: false,
  options: {
    customProperties: true,
    backgroundHome,
    logoHome: logoHome,
    toolbar: { dark: headerTextDark }
  },
  viewOptions: {
    Login: {
      showLogoLogin: showLogoLogin,
      logoLogin: logoLogin
    }
  },
  background,
  logo,
  themes: themes
}
